/**
 * Resumen de collectors para la lista (tabla `webadmin2_collector_stats`,
 * lambda collector_stats de webadmin2). Una sola lectura con processor / close /
 * active / settlement / cuentas / usuarios por collector.
 *
 * Es API de webadmin2 → JWT post-MFA (`webadmin2.jwt`), como debines.ts. No
 * confundir con collectors.ts, que habla con adminapi/CoreDB con el corejwt.
 */
const API_BASE =
  (import.meta.env.VITE_API_BASE as string | undefined) ?? "http://localhost:3000";

export interface CollectorSummaryRow {
  id:                 string;
  payments_processor: string;
  close_id:           string | null;
  active:             boolean;
  settlement:         boolean;
  accounts:           number;
  accounts_active:    number;
  users:              number;
  vendor_iid:         number | null;
  updated_at:         string | null;
}

export interface CollectorSummary {
  items:      CollectorSummaryRow[];
  rebuilt_at: string | null;
  status:     string | null;
  rebuilding: boolean;
}

function authHeader(): Record<string, string> {
  const jwt = localStorage.getItem("webadmin2.jwt");
  return jwt ? { Authorization: `Bearer ${jwt}` } : {};
}

async function authFetch(url: string, init: RequestInit = {}): Promise<Response> {
  const res = await fetch(url, init);
  if (res.status === 401) {
    localStorage.removeItem("webadmin2.jwt");
    localStorage.removeItem("webadmin2.email");
    if (typeof window !== "undefined") window.location.replace("/login");
  }
  return res;
}

export async function getCollectorSummary(): Promise<CollectorSummary> {
  const res = await authFetch(`${API_BASE}/collectors/summary`, { headers: authHeader() });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error ?? `getCollectorSummary: ${res.status}`);
  return data as CollectorSummary;
}

/** Dispara el rebuild completo (async). Devuelve el rebuilt_at previo para pollear el cambio. */
export async function rebuildCollectorSummary(): Promise<{ triggered: boolean; prev_rebuilt_at: string | null; reason?: string }> {
  const res = await authFetch(`${API_BASE}/collectors/summary/rebuild`, {
    method: "POST", headers: { "Content-Type": "application/json", ...authHeader() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error ?? `rebuildCollectorSummary: ${res.status}`);
  return data;
}
